import { PERMISSIONS } from '@repo/contracts';
import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { RequirePermission } from '@/routes/require-permission';

import { ADMIN_PATHS } from './admin-paths';

const WorkflowsPage = lazy(() => import('./workflows/WorkflowsPage'));
const WorkflowCreatePage = lazy(() => import('./workflows/WorkflowCreatePage'));
const WorkflowEditPage = lazy(() => import('./workflows/WorkflowEditPage'));
const FormsPage = lazy(() => import('./forms/FormsPage'));
const FormEditPage = lazy(() => import('./forms/FormEditPage'));
const FormCreatePage = lazy(() => import('./forms/FormCreatePage'));
const SigningTemplatesPage = lazy(() => import('./signing/SigningTemplatesPage'));
const SigningBuilderPage = lazy(() => import('./signing/SigningBuilderPage'));
const DirectNdaSettingsPage = lazy(() => import('./direct-nda/DirectNdaSettingsPage'));
const EmailsPage = lazy(() => import('./emails/EmailsPage'));
const EmailEditPage = lazy(() => import('./emails/EmailEditPage'));
const EmailCreatePage = lazy(() => import('./emails/EmailCreatePage'));

/**
 * Spread into the children of the signed-in layout route. Each area guards itself at the route,
 * so a page that would only be refused never mounts; the create routes need the manage permission.
 */
export const adminRoutes: RouteObject[] = [
  {
    element: <RequirePermission permission={PERMISSIONS.workflowRead} />,
    children: [
      { path: ADMIN_PATHS.workflows.list, element: <WorkflowsPage /> },
      { path: ADMIN_PATHS.workflows.detail(':id'), element: <WorkflowEditPage /> },
    ],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.workflowManage} />,
    children: [{ path: ADMIN_PATHS.workflows.create, element: <WorkflowCreatePage /> }],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.formTemplateRead} />,
    children: [
      { path: ADMIN_PATHS.forms.list, element: <FormsPage /> },
      { path: ADMIN_PATHS.forms.detail(':id'), element: <FormEditPage /> },
      { path: ADMIN_PATHS.signing.list, element: <SigningTemplatesPage /> },
    ],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.formTemplateManage} />,
    children: [
      { path: ADMIN_PATHS.forms.create, element: <FormCreatePage /> },
      { path: ADMIN_PATHS.signing.builderNew, element: <SigningBuilderPage /> },
      { path: ADMIN_PATHS.signing.builder(':templateRef'), element: <SigningBuilderPage /> },
    ],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.emailTemplateRead} />,
    children: [
      { path: ADMIN_PATHS.emails.list, element: <EmailsPage /> },
      { path: ADMIN_PATHS.emails.detail(':id'), element: <EmailEditPage /> },
    ],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.emailTemplateManage} />,
    children: [{ path: ADMIN_PATHS.emails.create, element: <EmailCreatePage /> }],
  },
  {
    element: <RequirePermission permission={PERMISSIONS.directNdaSettingsUpdate} />,
    children: [{ path: ADMIN_PATHS.directNdaSettings, element: <DirectNdaSettingsPage /> }],
  },
];
